// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"style_homeContainer__89N3q","centerContent":"style_centerContent__xrgF5","commonSidebar":"style_commonSidebar__uyNzj"};